module.exports = __webpack_public_path__ + "static/img/status1.9955935.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/user/status1.png
// module id = EQTo
// module chunks = 0